import { CMS_STATUS_TRANSITION_DEFAULTS } from "dash-common";

export const CMS_SETTINGS_DEFAULTS = {
  newListingToActiveDays: CMS_STATUS_TRANSITION_DEFAULTS.NEW_LISTING_TO_ACTIVE,
  activeToAwaitingAuditDays: CMS_STATUS_TRANSITION_DEFAULTS.ACTIVE_TO_AWAITING_AUDIT,
  recentlyUpdatedToActiveDays: CMS_STATUS_TRANSITION_DEFAULTS.RECENTLY_UPDATED_TO_ACTIVE,
  automatedTransitionsEnabled: true,
} as const;

export const CMS_SETTINGS_LIMITS = {
  MIN_DAYS: 1,
  MAX_DAYS: 365,
} as const;

export const INPUT_WIDTH = 200;